import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty, map as _map } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { RenderTableCellValue, RenderTableHeaderValue, showAlertMessage, ShowContentLoader, Select } from "../../resusableComponents/common/formElements";
import { downloadExcelFile } from "../../helpers/utils";
import { hasAccess } from "../../resusableComponents/hoc/AccessManagement";
import { withRouter } from "../../resusableComponents/hoc/withRouter";
import ReactDataTable from "../../resusableComponents/common/ReactDataTable";

import { LeadStatusWithAttributes, USER_ROLES } from "../../helpers/constants";

import { getClientAnalysisList, exportClientAnalysisData, doGetCampaignListByClient, doGetClientExportTemplate } from "../../redux/services/campaign";
import { doGetAgencyList, doGetClientList } from "../../redux/services/userMangement";
import { updateLoadingState } from "../../redux/actions/application";

class ClientAnalysis extends Component {

  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = {
      leadsList: [],
      agencyList: [],
      selectedAgency: null,
      clientList: [],
      selectedClient: null,
      campaignList: [],
      selectedCampaign: null,
      templateList: [],
      selectedTemplate: null,
      showLeadsTableLoader: true
    };

    this.hasPageViewAccess = hasAccess("analysis", "client-analysis", ["page-view"]);
    this.hasAgencyFilterAccess = hasAccess("analysis", "client-analysis", ["agency-filter"]);
    this.hasClientFilterAccess = hasAccess("analysis", "client-analysis", ["client-filter"]);
    this.hasCampaignFilterAccess = hasAccess("analysis", "client-analysis", ["campaign-filter"]);
    this.hasExportTemplateFilterAccess = hasAccess("analysis", "client-analysis", ["export-template-filter"]);
    this.hasExportButtonAccess = hasAccess("analysis", "client-analysis", ["export-button"]);
    this.hasResetButtonAccess = hasAccess("analysis", "client-analysis", ["reset-button"]);

    this.tableColumns = [
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.campaign_name", defaultMessage: "campaign" })} />),
        selector: (row) => _get(row, "campaign_name", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "campaign_name", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.lead_id", defaultMessage: "Lead ID" })} />),
        selector: (row) => _get(row, "lead_id", ""),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "lead_id", "")} tooltip={true} />),
        sortable: false,
        width: "90px"
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.date", defaultMessage: "Date" })} />),
        selector: (row) => (_get(row, "date", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "date", "")} tooltip={true} />),
        sortable: false,
        width: "90px"
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.company", defaultMessage: "Company" })} />),
        selector: (row) => (_get(row, "company", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "company", "")} tooltip={true} />),
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.name", defaultMessage: "Name" })} />),
        selector: (row) => (_get(row, "name", "")),
        cell: (row) => {
          if (!_isEmpty(_get(row, "personality_card_url", null))) {
            return (
              <a href={_get(row, "personality_card_url", "")} className="text-blue-22" target="_blank" rel="noreferrer">
                {_get(row, "name", "")}
              </a>
            )
          } else {
            return (<RenderTableCellValue className="text-truncate" value={_get(row, "name", "")} tooltip={true} />)
          }
        },
        sortable: false
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.email", defaultMessage: "email" })} />),
        selector: (row) => (_get(row, "email", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "email", "")} tooltip={true} />),
        sortable: false,
        width: "200px"
      },
      {
        name: (<RenderTableHeaderValue value={intl.formatMessage({ id: "client_analysis.table.job_title", defaultMessage: "Job Title" })} />),
        selector: (row) => (_get(row, "job_title", "")),
        cell: (row) => (<RenderTableCellValue className="text-truncate" value={_get(row, "job_title", "")} tooltip={true} />),
        sortable: false,
        width: "100px"
      }
    ];
  }

  componentDidMount() {
    this._fetchList();
    this._fetchAgency();
    this._fetchExportTemplate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!_isEqual(prevState.selectedAgency, this.state.selectedAgency)) ||
      (!_isEqual(prevState.selectedClient, this.state.selectedClient)) ||
      (!_isEqual(prevState.selectedCampaign, this.state.selectedCampaign))
    ) {
      this._fetchList();
    }

    if (!_isEqual(prevState.selectedAgency, this.state.selectedAgency) && (_get(this.state, "selectedAgency.id", null) !== null)) {
      this._fetchClient();
    }

    if (!_isEqual(prevState.selectedClient, this.state.selectedClient)) {
      if ((_get(this.state, "selectedClient.id", null) !== null)) {
        this._fetchCampaign();
      }

      this._fetchExportTemplate();
    }
  }

  _fetchAgency = async () => {
    const { updateLoadingState, agencyId, roleId, agencyName } = this.props;

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      let selAgencyList = null;
      const selAgencyId = [_get(USER_ROLES, "AGENCY.id", "0"), _get(USER_ROLES, "AGENCY_ACCOUNTS.id", "0")].includes(roleId) ? agencyId : null;

      const response = await doGetAgencyList({ dropdown_flag: 1, agency_id: selAgencyId });

      if (([_get(USER_ROLES, "AGENCY.id", "0"), _get(USER_ROLES, "AGENCY_ACCOUNTS.id", "0")].includes(roleId))) {
        selAgencyList = { "id": agencyId, "agency_name": agencyName };
      }

      if (_get(response, "flag", false) === true) {

        this.setState({
          agencyList: _get(response, "data.responseData.agency_list", []),
          selectedAgency: selAgencyList, clientList: [], selectedClient: null, campaignList: [], selectedCampaign: null,
          templateList: [], selectedTemplate: null
        });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching agency.")));
        this.setState({ agencyList: [], selectedAgency: selAgencyList, clientList: [], selectedClient: null, campaignList: [], selectedCampaign: null, templateList: [], selectedTemplate: null });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching agency.")));
      this.setState({ agencyList: [], selectedAgency: null, clientList: [], selectedClient: null, campaignList: [], selectedCampaign: null, templateList: [], selectedTemplate: null });
    } finally {

      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _fetchClient = async () => {
    const { updateLoadingState } = this.props;
    const { selectedAgency } = this.state;

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetClientList({ agency_id: _get(selectedAgency, "id", null), dropdown_flag: 1 });

      if ((response.flag || false) === true) {

        this.setState({ clientList: _get(response, "data.responseData.client_list", []), selectedClient: null, campaignList: [], selectedCampaign: null, templateList: [], selectedTemplate: null });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching client.")));

        this.setState({ clientList: [], selectedClient: null, campaignList: [], selectedCampaign: null, templateList: [], selectedTemplate: null });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching client.")));

      this.setState({ clientList: [], selectedClient: null, campaignList: [], selectedCampaign: null, templateList: [], selectedTemplate: null });
    } finally {

      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _fetchCampaign = async () => {
    const { updateLoadingState } = this.props;
    const { selectedClient } = this.state;

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetCampaignListByClient({ client_id: _get(selectedClient, "id", null), search_text: "" });

      if ((response.flag || false) === true) {

        this.setState({ campaignList: _get(response, "data.responseData", []), selectedCampaign: null });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching campaign list.")));
        this.setState({ campaignList: [], selectedCampaign: null });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching campaign list.")));
      this.setState({ campaignList: [], selectedCampaign: null });
    } finally {

      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _fetchExportTemplate = async () => {
    const { updateLoadingState } = this.props;
    const { selectedClient } = this.state;

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetClientExportTemplate({ client_id: _get(selectedClient, "id", null) });

      if (_get(response, "flag", false) === true) {

        this.setState({ templateList: _get(response, "data.responseData", []), selectedTemplate: null });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching export template list.")));
        this.setState({ templateList: [], selectedTemplate: null });
      }
    } catch (error) {
      showAlertMessage((_get(error, "message", "Something went wrong while fetching export template list.")));
      this.setState({ templateList: [], selectedTemplate: null });
    } finally {

      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _fetchList = async () => {
    const { updateLoadingState } = this.props;
    const { selectedAgency, selectedClient, selectedCampaign } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }
      this.setState({ showLeadsTableLoader: true });

      const response = await getClientAnalysisList({
        "match_key": "",
        "orderby": "lead_id",
        "order": "desc",
        "agency_ids": (_get(selectedAgency, "id", null)) ? [_get(selectedAgency, "id", null)] : [],
        "client_ids": (_get(selectedClient, "id", null)) ? [_get(selectedClient, "id", null)] : [],
        "campaign_ids": _map(selectedCampaign, "id"),
      });

      if (_get(response, "flag", false) === true) {
        this.setState({ showLeadsTableLoader: false, leadsList: _get(response, "data.lead_items", []) });
      } else {
        showAlertMessage((_get(response, "message", "Something went wrong while fetching client analysis data.")));
      }

    } catch (err) {
      showAlertMessage((_get(err, "message", "Something went wrong while fetching client analysis data.")));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  }

  _handleExport = async () => {
    const { updateLoadingState, intl } = this.props;
    const { selectedAgency, selectedClient, selectedCampaign, selectedTemplate } = this.state;

    const templateId = _get(selectedTemplate, "id", null);
    if (!templateId) {
      showAlertMessage("Please select export template.");
      return false;
    }

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const payload = {
        "campaign_ids": _map(selectedCampaign, "id"),
        "agency_ids": (_get(selectedAgency, "id", null)) ? [_get(selectedAgency, "id", null)] : [],
        "client_ids": (_get(selectedClient, "id", null)) ? [_get(selectedClient, "id", null)] : [],
        "template_id": (templateId || null),
      };

      const response = await exportClientAnalysisData(payload);

      if (_get(response, "flag", false) === true) {

        const downloadFileDetails = _get(response, "data", []);

        const contentType = (downloadFileDetails.contentType || "");
        const contents = (downloadFileDetails.Contents || "");
        const filename = (downloadFileDetails.filename || "");

        if ((contentType !== "") && (contents !== "") && (filename !== "")) {
          downloadExcelFile(contentType, contents, filename);

          showAlertMessage(intl.formatMessage({ id: "message.file_generated_successfully", defaultMessage: "File generated successfully." }), "success");
        }

      } else {
        showAlertMessage(response.message || "Something went wrong while exporting data.");
      }

    } catch (err) {
      showAlertMessage(err.message || "Something went wrong while exporting data.");
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _handleResetFilter = () => {
    this.setState({
      leadsList: [],
      selectedAgency: null,
      clientList: [],
      selectedClient: null,
      campaignList: [],
      selectedCampaign: null,
      templateList: [],
      selectedTemplate: null,
      showLeadsTableLoader: true
    });
  }

  _renderQAStatus = (row, path, isDelivery = 0) => {
    const qaStatus = _get(row, path, 0);

    let _html = "";

    // if ([0, 1, 3].includes(qaStatus)) {
    if (qaStatus === 1) {
      _html = (
        <span className={`badge ${LeadStatusWithAttributes.labelClass[qaStatus] || ""}`}>
          {(LeadStatusWithAttributes.qaLabels[qaStatus] || "")}
        </span>
      )
    } else {
      let reason = "";
      if (isDelivery === 1) {
        reason = _get(row, "delivery_fail", "");
      } else {
        reason = _get(row, "criteria_fail", "");
      }
      _html = (
        <div className={`${LeadStatusWithAttributes.labelFontClass[qaStatus] || ""} w-100`}>
          <span className="text-truncate d-block" title={reason}>{reason}</span>
        </div>
      )
    }

    return _html;
  }

  _renderApprovedStatus = (row, path) => {
    let _html = "";

    const status = _get(row, path, 0);

    const labelClass = (LeadStatusWithAttributes.labelClass[status] || "");
    const labelFontClass = (LeadStatusWithAttributes.labelFontClass[status] || "");
    const labelText = (LeadStatusWithAttributes.approveLabels[status] || "");

    if (status === 1) {
      _html = !_isEmpty(labelText) ? (
        <span className={`badge ${labelClass}`}>{labelText}</span>
      ) : "";
    } else {
      const reason = _get(row, "approval_fail", "");
      _html = !_isEmpty(reason) ? (
        <span className={`badge ${labelClass || ""} ${labelFontClass || ""} text-truncate d-block`} title={reason}>{reason}</span>
      ) : "";
    }

    return _html;
  }

  _renderTopFilters = () => {
    const { roleId, intl } = this.props;
    const { agencyList, selectedAgency, clientList, selectedClient, campaignList, selectedCampaign, templateList, selectedTemplate } = this.state;

    return (
      <>
        <div className="row gy-5">
          {(hasAccess("analysis", "client-analysis", ["agency-filter"])) && (
            <div className="col-lg-2">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="client_analysis.filter.label_agency" defaultMessage="agency" />
                </label>
                <Select
                  className="form-custom-select text-capitalize"
                  placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" }, {
                    field: intl.formatMessage({ id: "client_analysis.filter.label_agency", defaultMessage: "agency" })
                  })}
                  options={(agencyList || [])}
                  value={(selectedAgency || null)}
                  getOptionLabel={(option) => (option.agency_name || "")}
                  getOptionValue={(option) => (option.id || null)}
                  onChange={(selected) => this.setState({ selectedAgency: selected, selectedClient: null, selectedCampaign: null })}
                  isDisabled={[_get(USER_ROLES, "AGENCY.id", "0"), _get(USER_ROLES, "AGENCY_ACCOUNTS.id", "0")].includes(roleId) ? true : false}
                  isMulti={false}
                />
              </div>
            </div>
          )}

          {(hasAccess("analysis", "client-analysis", ["client-filter"])) && (
            <div className="col-lg-2">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="client_analysis.filter.label_client" defaultMessage="client" />
                </label>
                <Select
                  className="form-custom-select text-capitalize"
                  placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" }, {
                    field: intl.formatMessage({ id: "client_analysis.filter.label_client", defaultMessage: "client" })
                  })}
                  options={(clientList || [])}
                  value={(selectedClient || null)}
                  getOptionLabel={(option) => (option.client_name || "")}
                  getOptionValue={(option) => (option.id || null)}
                  onChange={(selected) => this.setState({ selectedClient: selected, selectedCampaign: null })}
                  isMulti={false}
                />
              </div>
            </div>
          )}

          {(hasAccess("analysis", "client-analysis", ["campaign-filter"])) && (
            <div className="col-lg-3">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="client_analysis.filter.label_campaign" defaultMessage="campaign" />
                </label>
                <Select
                  className="form-custom-select text-capitalize"
                  placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" }, {
                    field: intl.formatMessage({ id: "client_analysis.filter.label_campaign", defaultMessage: "campaign" })
                  })}
                  options={(campaignList || [])}
                  value={(selectedCampaign || null)}
                  getOptionLabel={(option) => (option.name || "")}
                  getOptionValue={(option) => (option.id || null)}
                  onChange={(selected) => this.setState({ selectedCampaign: selected })}
                />
              </div>
            </div>
          )}

          {(hasAccess("analysis", "client-analysis", ["export-template-filter"])) && (
            <div className="col-lg-3">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="client_analysis.filter.label_export_template" defaultMessage="export template" />
                  <span className="text-danger">*</span>
                </label>
                <Select
                  className="form-custom-select text-capitalize"
                  placeholder={intl.formatMessage({ id: "placeholder.select_field", defaultMessage: "Select {field}" }, {
                    field: intl.formatMessage({ id: "client_analysis.filter.label_export_template", defaultMessage: "export template" })
                  })}
                  options={(templateList || [])}
                  value={(selectedTemplate || null)}
                  getOptionLabel={(option) => (option.name || "")}
                  getOptionValue={(option) => (option.id || null)}
                  onChange={(selected) => this.setState({ selectedTemplate: selected })}
                  isMulti={false}
                />
              </div>
            </div>
          )}

          {(hasAccess("campaigns", "view-leads", ["export"])) && (
            <div className="col-lg-1 mt-12">
              <button className="btn btn-outline-primary waves-effect w-100" onClick={() => this._handleExport()}>
                <FormattedMessage id="btn.export" defaultMessage="export" />
              </button>
            </div>
          )}

          <div className="col-lg-1 mt-12">
            <button className="btn btn-dark waves-effect" onClick={() => this._handleResetFilter()}>
              <FormattedMessage id="btn.reset" defaultMessage="Reset" />
            </button>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { showLeadsTableLoader, leadsList } = this.state;

    return (
      <>
        <div className="container-fluid flex-grow-1 px-6 py-6">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase mb-5">
                <FormattedMessage id="client_analysis.title" defaultMessage="client analysis" />
              </h1>
            </div>
          </div>

          {(
            (this.hasPageViewAccess) && (
              (this.hasAgencyFilterAccess) ||
              (this.hasClientFilterAccess) ||
              (this.hasCampaignFilterAccess) ||
              (this.hasExportTemplateFilterAccess) ||
              (this.hasExportButtonAccess) ||
              (this.hasResetButtonAccess)
            )
          ) && (
              <>
                {this._renderTopFilters()}

                <div className="row mt-5">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body py-5">
                        <div className="table-responsive custom-scroll">
                          <ReactDataTable
                            className="custom-scroll-460 leadsTable"
                            columns={this.tableColumns}
                            data={(leadsList || [])}
                            progressPending={showLeadsTableLoader}
                            showLeadsTableLoader
                            progressComponent={<ShowContentLoader />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  roleId: _get(state, "authentication.user.role_id", 0),
  agencyId: _get(state, "authentication.user.agency_id", null),
  agencyName: _get(state, "authentication.user.agency_name", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ClientAnalysis)));
